import React, { useEffect, useState } from 'react'
import CustomQuestBox from '../components/globals/CustomQuestBox'
import CustomBusinessMoneyButton from '../components/globals/CustomBusinessMoneyButton'
import LeaderBoardImage from '../components/globals/LeaderBoardImage'
import one from '../assets/images/1.png'
import two from '../assets/images/2.png'
import three from '../assets/images/3.png'
import BuyCoinComponent from '../components/globals/BuyCoinComponent'
import QuestionItem from '../components/globals/QuestionItem';
import CustomModal from '../components/globals/CustomModal';
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil';
import { isLoaderState } from '../store/RecoilStore';
import { ENDPOINTS } from '../utils/EndPoint';
import { oceanAtom } from '../store/oceanAtom';
import { userAtom } from '../store/authAtom';
import { apiGetAuth, apiPost } from '../utils/Api';
import TableComponent from '../components/globals/TableComponent'
import CustomPrimaryButton from '../components/globals/CustomPrimaryButton'
import CustomSecondaryButton from '../components/globals/CustomSecondaryButton';
import sharklogo from '../assets/images/NextGen-Blue.png';
import { Modal } from 'react-bootstrap'

function LeaderBoard() {

  const [lastCompleteIndex, setLastCompleteIndex] = useState(0);

const [advertModal,setAdvertModal] = useState(false)

useEffect(()=>{
  setAdvertModal(true)
},[])
  const [showModal, setShowModal] = useState(false);
  const [showGuestModal, setGuestModal] = useState(false);
  const [oceans, setOceans] = useState([]);
  const [isLoaderInfo, setIsLoaderInfo] = useRecoilState(isLoaderState);
  const [ocean, setOcean] = useRecoilState(oceanAtom);
  const ocean_id = ocean?.id;

  const [user, setUser] = useRecoilState(userAtom);
  const [stages, setStages] = useState([]);
  const [countries, setCountries] = useState([]);
  const [leaderboard, setLeaderBoard] = useState([]);

  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [selectedQuest, setSelectedQuest] = useState(null);

  const handleQuestClick = (quest, index) => {
    if (index <= lastCompleteIndex) {
      setSelectedQuest(quest);
      setSelectedQuestId(quest?.id);

      navigate('/challenge-question-answers', {
        state: {
          selectedQuest: quest,
          ocean,
          stages,
          lastCompleteIndex
        },
      });
    }
  };

  useEffect(() => {
    if (stages) {
      setGuestModal(true);
    }
  }, [stages]);

  const navigate = useNavigate();

  const handleSelectOcean = (item) => {
    setOcean(item)
    apiPost(
      ENDPOINTS.UserSelectedOption,
      { ocean_id: item?.id },
      (res) => {
        getQuests(item?.id)
        setShowModal(false);
      },
      (err) => {
        console.log("Error updating user selected option", err);
      }
    );
  }

  const getLeaderBoard = async (oceanId) => {
    setIsLoaderInfo(true)
    apiGetAuth(
      `${ENDPOINTS.GetLeaderBoard}?ocean_id=${oceanId}`,
      (res) => {
        console.log(res, "resresresresres");

        setLeaderBoard(res);
        setIsLoaderInfo(false);
      },
      (err) => {
        console.log("err", err)
        setIsLoaderInfo(false)
      }
    );
  }

  useEffect(() => {
    getOceans();
    getLeaderBoard(ocean?.id);
    fetch(
      "https://valid.layercode.workers.dev/list/countries?format=select&flags=true&value=code"
    )
      .then((response) => response.json())
      .then((data) => {
        setCountries(data.countries);
      });
  }, []);

  const getQuests = async (oceanId) => {
    setIsLoaderInfo(true)
    apiGetAuth(
      `${ENDPOINTS.GetChallenges}?ocean_id=${oceanId}`,
      (res) => {
        const count = res.filter(stage => stage.user_quest !== null).length;
        setStages(res);
        setLastCompleteIndex(count);
        setIsLoaderInfo(false);
      },
      (err) => {
        console.log("err", err)
        setIsLoaderInfo(false)
      }
    );
  }

  const getOceans = async () => {
    setIsLoaderInfo(true)
    apiGetAuth(
      ENDPOINTS.GetOceans,
      (res) => {
        const oceanWithUserOption = res.find(ocean => ocean.user_selected_option != null);
        if (oceanWithUserOption) {
          setOcean(oceanWithUserOption);
          getQuests(oceanWithUserOption?.id);
        } else {
          const defaultOcean = res[0];
          if (defaultOcean) {
            setOcean(defaultOcean);
            getQuests(defaultOcean?.id);
          }
        }
        setOceans(res)
        setIsLoaderInfo(false)
      },
      (err) => {
        console.log("err", err)
        setIsLoaderInfo(false)
      }
    );
  }

  const columns = [
    {
      name: 'ID',
      selector: (row) => row?.position,
      sortable: false,
      width: '60px',
    },
    {
      name: 'Flag',
      selector: (row) => {
        const country = countries.find((country) => country.value === row?.user?.flag);
        return country ? <img src={country.flag} alt={country.label} width="30" /> : null;
      },
      sortable: false,
    },
    {
      name: 'Name',
      selector: (row) => row?.user?.name,
      sortable: false,
    },
    {
      name: 'Score',
      selector: (row) => row?.score,
      sortable: false,
    },
  ];

  return (
    <div className='quest'>
      <div className='container-fluid p-4'>
        <div className='d-flex justify-content-between align-items-center pb-5 custom-leaderboard-mb-class'>
          <CustomBusinessMoneyButton
            btnTextPro={ocean ? ocean?.name : "Select Ocean"}
            classNamePro="btn-custom-leaderboard"
            customWelcomeClass="custom-leaderboard-class"
            handleOnClick={() => setShowModal(true)}
          />
          <BuyCoinComponent handleOnClick={() => navigate('/admin/coin-purchase')} />
        </div>
        <div className='row d-flex align-items-center'>


          {stages.map((quest, index) => (
            <div key={index} className='col-lg-6'>
              <CustomQuestBox
                isLocked={index > lastCompleteIndex}
                quest={quest}
                questionsCount={`${Math.min(quest.correct_question_answers_count || 0, quest.questions_count || 0)} / ${quest.total_questions || 0}`}
                isLeaderBoard={true}
                handleClick={() => handleQuestClick(quest, index)}
              />
            </div>
          ))}


          <div className='col-lg-6'>
            <div className="grid-container pt-5">
              {leaderboard && leaderboard.length > 0 && leaderboard.map((leader, index) => {
                const baseUrl = process.env.REACT_APP_BASE_URL;
                return (
                  <>
                    {leader.position === 2 ? (
                      <div className="grid-item second-position">
                        <LeaderBoardImage
                          leaderBoardImg="leader-board-image"
                          awardImage={two}
                          profileImage={
                            leader.user.image
                              ? `${baseUrl}/${leader.user.image}`
                              : `${baseUrl}/images/avatar.webp`
                          }
                        />
                      </div>
                    ) : leader.position === 1 ? (
                      <div className="grid-item first-position">
                        <LeaderBoardImage
                          isFirst={true}
                          leaderBoardImg="leader-board-image"
                          awardImage={one}
                          profileImage={
                            leader.user.profile_picture?.media_path
                              ? `${baseUrl}/${leader.user.profile_picture.media_path}`
                              : `${baseUrl}/images/avatar.webp`
                          }
                        />
                      </div>
                    ) : leader.position === 3 ? (
                      <div className="grid-item third-position">
                        <LeaderBoardImage
                          leaderBoardImg="leader-board-image"
                          awardImage={three}
                          profileImage={
                            leader.user.profile_picture?.media_path
                              ? `${baseUrl}/${leader.user.profile_picture.media_path}`
                              : `${baseUrl}/images/avatar.webp`
                          }
                        />
                      </div>
                    ) : null}
                  </>
                );
              })}
            </div>

            <div className='mt-5 pb-3'>
              <div className='leaderboard-table mt-3'>
                <TableComponent
                  title={"Transaction History"}
                  endPoint={`${ENDPOINTS.GetPaginatedLeaderBoard}`}
                  headers={columns}
                  searchObject={{ ocean_id }}
                  className="transaction-history"
                  customTableClass="custom-wallet-table"
                />
              </div>

            </div>
          </div>
        </div>

      </div>

      {user?.type === "guest_user" && (
        <CustomModal
          size="md"
          hideModal={() => navigate("/admin/ocean")}
          showModal={showGuestModal}
          title="Select Ocean"
        >
          <div className="ocean-modal text-center">
            <h2 className='text-white font-24 text-bold skranji-regular'>This feature is not available for guest users</h2>
            <div class="buttons d-flex justify-content-center">
              <CustomSecondaryButton
                btnTextPro="Cancel"
                classNamePro="btn btn-seondary"
                handleOnClick={() => navigate("/admin/ocean")}
              />
              <CustomPrimaryButton
                btnTextPro="Sign Up"
                classNamePro="btn btn-primary mt-2"
                handleOnClick={() => {
                  navigate("/register-form");
                }}
              />
            </div>
          </div>
        </CustomModal>
      )}

      <CustomModal
        size={'md'}
        hideModal={() => setShowModal(false)}
        showModal={showModal}
        title="Select Ocean"
        onClose={() => setShowModal(false)}
      >
        <div className='ocean-modal text-center'>
          <h2 className='text-white'>Select Ocean</h2>
          {oceans && oceans.length > 0 ? (
            oceans.map((item, ind) => (
              <QuestionItem
                key={ind}
                welcomeicon={`${process.env.REACT_APP_BASE_URL}/${item.image}`}
                text={item.name}
                progressBar={{ now: item.percentage }}
                customTime="4 Hours"
                onClick={() => handleSelectOcean(item)}
                isSelected={ocean?.id === item?.id}
              />
            ))
          ) : (
            <div><p>No Ocean</p></div>
          )}
        </div>
      </CustomModal>
      <Modal show={advertModal} onHide={() => setAdvertModal(false)}  centered>
        <Modal.Header closeButton>
          <Modal.Title>Advertisement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
              <img src={sharklogo} className="d-block mx-auto  logo" alt="Logo" />
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default LeaderBoard